// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TextEditorToolbarLinkButton{color:red}", "",{"version":3,"sources":["webpack://./src/main/js/common/components/text-editor/components/toolbar-link-button/toolbar-link-button.styles.scss"],"names":[],"mappings":"AAAA,6BACE,SAAA","sourcesContent":[".TextEditorToolbarLinkButton {\n  color: red;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
